import { SupportedLanguages } from '../types';

export const getTwoLetterLanguageCode = (
    languageCode: string,
    fallbackLanguage: SupportedLanguages = SupportedLanguages.en,
): string => {
    const twoLetterLanguageAbbreviation: string = languageCode.substring(0, 2);
    return Object.keys(SupportedLanguages).includes(twoLetterLanguageAbbreviation)
        ? twoLetterLanguageAbbreviation
        : fallbackLanguage;
};
